module.exports = __webpack_public_path__ + "static/media/WeddingPhotographers.e0c7474a.png";